import addSheet from "./addSheet.js";
import { getFunctionUrl } from "./functionEndpoints.js";
import {
  DEFAULT_PARAMS,
  parseParamsSheet,
  writeParamsSheet,
} from "./paramsSheet.js";

export const readParams = async (metadata, spreadsheetAccessData, callback) => {                    
  const matchingSheet = metadata.find(
    (sheet) =>
      String(sheet?.properties?.title ?? "").trim().toLowerCase() === "params"
  );
  const sheetTitle = matchingSheet?.properties?.title ?? "params";

  if (!matchingSheet) {
    await addSheet(sheetTitle, spreadsheetAccessData);
    await writeParamsSheet(spreadsheetAccessData, DEFAULT_PARAMS, sheetTitle);
    callback(DEFAULT_PARAMS);
    return DEFAULT_PARAMS;                                                                                       
  }                                                                                                  
  // Keep the params read wide enough to cover the FSRS weights row.
  // eslint-disable-next-line
  let range = `${sheetTitle}!A:Z`                                                                        
  const url = getFunctionUrl("get-sheet-values")
  const requestBody = JSON.stringify({                                                               
    range: range,                                                                                    
    ...spreadsheetAccessData                                                                         
  });                                                                                                
  const req = await fetch(url, {body: requestBody, headers: {"Content-Type": "application/json"}, method: 'POST'})                                   
  const sheet = await req.json();       
  const params = parseParamsSheet(sheet);
  await writeParamsSheet(spreadsheetAccessData, params, sheetTitle);

  // read cards from spreadsheetLink
  //
  // update cards by doing callback
  callback(params);
  return params;
}

export default readParams;
